(function () {
  'use strict';

  function CancelOrderCtrl (orderId, cartId, $uibModalInstance, ordersFactory) {
    const vm = this;

    function throwError (err) {
      vm.errorMessage = err.data.errorMessage;
    }

    function closeModal () {
      $uibModalInstance.close();
    }

    function confirmCancelOrder () {
      vm.processing = true;
      vm.errorMessage = false;
      ordersFactory.cancelOrder(orderId)
        .then(closeModal, throwError)
        .catch(throwError);
    }

    function cancel () {
      $uibModalInstance.dismiss();
    }

    function activate () {
      // data bindings
      vm.orderId = orderId;
      vm.cartId = cartId;
      vm.processing = false;
      vm.language = pnTopbar.language;

      // methods
      vm.confirmCancelOrder = confirmCancelOrder;
      vm.closeModal = closeModal;
      vm.cancel = cancel;
    }

    activate();
  }

  angular.module('web2print.orders')
    .controller('CancelOrderCtrl', CancelOrderCtrl);

  CancelOrderCtrl.$inject = ['orderId', 'cartId', '$uibModalInstance', 'ordersFactory'];
})();
